export const SIGNUP_COMPLETE_ROUTE = 'CompletedSignUp'
